import * as React from 'react';
import {createCss} from '@sail/engine/deprecated';
import {css} from '../css';
import {view} from '../view';

// Currently, animating custom properties is currently not possible.
// We use createCss instead of deprecatedCss, because deprecatedCss is configured with a transform plugin.
// createCss still comes from the deprecated system; the newer system doesn’t support @keyframes yet

// TODO(jackl) remove this when engine supports keyframes
export const rawCss = createCss([], {layer: 'headless'});

const animation = rawCss`
  animation: SpinnerAnimationShow 250ms normal ease, SpinnerAnimationRotation .7s linear infinite;
  transition-property: opacity, transform;
  transition-timing-function: ease;
  transform-origin: 50% 50%;

  @keyframes SpinnerAnimationShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
 
  @keyframes SpinnerAnimationRotation {
    from {
      transform: rotateZ(0);
    }
    to {
      transform: rotateZ(360deg);
    }
  }
`;

const {useEffect, useState} = React;

type SizeScale = 'small' | 'medium' | 'large';

/**
 * @external
 */
interface SpinnerProps {
  /**
   * Delay applied to animation
   * @external
   */
  delay?: number;

  /**
   * Size of Spinner component
   * @external
   */
  size?: SizeScale;
}

const sizeInPx: {[_K in SizeScale]: number} = {
  small: 12,
  medium: 16,
  large: 24,
};

/**
 * @external
 */
export const Spinner = view.span.create<SpinnerProps>(
  ({delay, size = 'medium', ...props}, View) => {
    const [shown, setShown] = useState(!delay);

    useEffect(() => {
      if (delay) {
        const timeout = setTimeout(() => {
          setShown(true);
        }, delay);

        return () => clearTimeout(timeout);
      }
    }, [delay, setShown]);

    if (!shown) {
      return null;
    }

    return (
      <View uses={[props]}>
        <view.svg
          viewBox="0 0 24 24"
          role="status"
          aria-label="Loading"
          uses={[
            animation,
            css({
              color: css.value('$color.neutral400'),
              height: css.value(`${sizeInPx[size]}px`),
            }),
          ]}
        >
          <g transform="translate(1 1)" fillRule="nonzero" fill="none">
            <circle cx="11" cy="11" r="11" />
            <path
              d="M10.998 22a.846.846 0 0 1 0-1.692 9.308 9.308 0 0 0 0-18.616 9.286 9.286 0 0 0-7.205 3.416.846.846 0 1 1-1.31-1.072A10.978 10.978 0 0 1 10.998 0c6.075 0 11 4.925 11 11s-4.925 11-11 11z"
              fill="currentColor"
            />
          </g>
        </view.svg>
      </View>
    );
  },
);
